<template>
  <div>
    <b-row>
      <!-- main -->
      <b-col cols="4" class="main-box">
        <back-button :to="{ name: 'Deals' }"/>

        <b-form @submit="onSubmit" size="sm">

          <b-form-group label="Название">
            <b-form-input
              v-model="deal.title"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <b-card no-body>
            <b-tabs card>
              <b-tab title="Основное">
                <b-card-text>
                  <b-form-group label="Теги">
                    <tags v-bind:value="deal.tags"
                          v-on:input="deal.tags = $event"></tags>
                  </b-form-group>

                  <b-row>
                    <b-col cols="4">
                      <b-form-group label="Сумма">
                        <b-form-input
                          v-model="deal.amount"
                          type="number" step="0.01"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-group label="Дата оплаты">
                        <b-form-datepicker
                          v-model="deal.paymentAt"
                          locale="ru"
                          :start-weekday="1"
                          reset-button
                        ></b-form-datepicker>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group label="Статус">
                    <b-form-select v-model="deal.status" :options="statusOptions"></b-form-select>
                  </b-form-group>

                  <b-form-group label="Контакты:" class="bold">
                    <contacts v-model="deal.contacts" v-on:input="deal.contacts=$event"></contacts>
                  </b-form-group>
                </b-card-text>
              </b-tab>
              <b-tab title="Сделка">
                <b-card-text>
                  <b-form-group label="Воронка:">
                    <b-form-select v-model="deal.funnel" :options="$store.getters.funnelOptions"></b-form-select>
                  </b-form-group>
                  <!--                                    <b-form-group label="Ответственный:">-->
                  <!-- TODO: уточнить -->
                  <!--                                     </b-form-group>-->
                  <b-form-group label="Канал:">
                    <b-form-select :options="channelOptions" v-model="deal.channel"></b-form-select>
                  </b-form-group>

                  <b-form-group label="Компания:" class="bold">
                    <company-list-entry :company="deal.company"></company-list-entry>
                  </b-form-group>

                  <b-form-group label="Дата создания">
                    <b-form-input
                      :value="dateTimeFormat(deal.createdAt)"
                      type="text" :disabled="true"
                    ></b-form-input>
                  </b-form-group>
                </b-card-text>
              </b-tab>
              <b-tab title="Файлы">
                <b-card-text>
                  <file-list :files="deal.files"></file-list>
                </b-card-text>
              </b-tab>
              <b-tab title="Задачи">
                <template #title>
                  Задачи
                  <b-spinner v-if="tasksLoading" type="border" small></b-spinner>
                  <b-badge variant="primary" v-if="deal.tasks && deal.tasks.length > 0">{{ deal.tasks.length }}</b-badge>
                </template>
                <b-card-text>
                  <task-list :tasks="deal.tasks" @refresh="fetchDeal"></task-list>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>

          <!--<br/>-->

          <div class="mt-5">
            <loading-button class="mb-3" :isFullwidth="true" :is-busy="isBusy"></loading-button>
            <b-button v-on:click="itemToDelete = deal.id" block variant="link" v-b-modal.modal-delete class="text-danger">
              <!--<b-icon icon="trash-fill" aria-hidden="true"></b-icon>-->
              Удалить сделку
            </b-button>
          </div>
        </b-form>
      </b-col>
      <!-- comments -->
      <b-col cols="8" class="comments-box">
        <comments :entity="deal" entity-type="deal"></comments>
      </b-col>
    </b-row>
    <b-modal id="modal-delete" title="Удаление сделки" @ok="remove(itemToDelete)" cancel-title="Отмена" ok-title="Удалить" ok-variant="danger">
      <p class="alert-warning">После удаления сделки, восстановить ее содержимое (а так же прикрепленные файлы, задачи и комментарии) будет невозможно!</p>
      <p>Вы действительно желаете удалить сделку?</p>
    </b-modal>
  </div>
</template>

<script>
import Tags from "../components/tags";
import BackButton from "../components/BackButton";
import Contacts from "../components/ContactsAssignable";
import LoadingButton from "../components/LoadingButton";
import CompanyListEntry from "../components/CompanyListEntry";
import FileList from "../components/FileList";
import TaskList from "../components/TaskList";
import Comments from "../components/Comments";
import datapickerMixin from '../mixins/datapicker';

export default {
  name: "Deal",
  components: {Comments, FileList, CompanyListEntry, LoadingButton, Contacts, Tags, TaskList, BackButton},
  mixins: [datapickerMixin],
  data() {
    return {
      channelOptions: [
        {value: 'youtube', text: 'YouTube'},
        {value: 'adwords', text: 'AdWords'},
        {value: 'yandex', text: 'Яндекс'},
        {value: 'offline', text: 'Оффлайн мероприятия'},
        {value: 'webinars', text: 'Вебинары'},
        {value: 'exhibitions', text: 'Выставки'},
        {value: 'mail', text: 'Рассылка'}
      ],
      tasksLoading: false,
      isBusy: false,
      totalRows: 1,
      errorResult: null,
      messageResult: '',
      perPage: 20,
      currentPage: 1,
      error: false,
      message: '',
      items: [],
      itemToDelete: null,
      deal: {
        id: 0,
        title: '',
        amount: '',
        status: '',
        funnel: '',
        tags: [],
        tasks: [],
        company: {},
        paymentAt: '',
      }
    }
  },
  mounted() {
    this.fetchDeal();
  },
  computed: {
    statusOptions() {
      let funnels = [];
      funnels = this.$store.getters.funnels.filter(funnel => funnel.name === this.deal.funnel)
      if (funnels.length === 0) return [];
      let opts = [];
      let exists = false;
      funnels[0].statuses.forEach(e => {
        opts.push({value: e.name, text: e.title});
        if (e.name === this.deal.status) exists = true;
      });
      if (!exists) this.setDealStatus(opts[0].value);

      return opts;
    }
  },
  methods: {
    setDealStatus(value) {
      this.deal.status = value;
    },
    fetchDeal() {
      this.error = false;
      this.isBusy = true;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/deals/' + this.$route.params.id, {})
        .then((response) => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.deal = response.data.deal
              if (this.deal.tags === null || this.deal.tags === undefined) {
                this.deal.tags = [];
              }
              this.fetchTasks(this.deal.id)
            } else {
              this.error = true;
              this.message = response.data.message;
            }
          }
        })
        .catch(e => {
          console.error(e);
          this.error = true;
          this.message = e.error;
        })
        .finally(() => {
          this.isBusy = false;
        })
    },
    submitSearch() {

    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = false;
      this.isBusy = true;
      this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/deals/' + this.deal.id, JSON.stringify(this.deal)
      ).then((response) => {
        this.isBusy = false;
        if (response) {
          if (response.data.error === false) {
            this.error = false;

          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      }).catch((error) => {
        this.isBusy = false;
        console.log(error);
      });
    },
    remove(id) {
      this.axios.delete(process.env.VUE_APP_BACKEND_URL + '/api/deals/' + id)
        .then(response => {
          if (response && !response.data.error) {
            this.error = false;
            this.$router.push({name: 'Deals'});
          } else {
            this.$bvToast.toast(`Ошибка удаления сделки: ${response.data?.message}`, {
              title: 'Ошибка',
              autoHideDelay: 5000,
            })
          }
        }).catch((error) => {
        console.log(error);
        this.$bvToast.toast(`Ошибка удаления сделки`, {
          title: 'Ошибка',
          autoHideDelay: 5000,
        })
      });
    },
    fetchTasks(id) {
      this.tasksLoading = true;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/deals/' + id + '/tasks', {})
        .then((response) => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.$set(this.deal, 'tasks', response.data.tasks)
            } else {
              this.error = true;
              this.message = response.data.message;
              this.$set(this.deal, 'tasks', [])
            }
          }

        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.tasksLoading = false;
        })
    },
  }
}
</script>

<style scoped>
.main-box {
  min-height: 100vh;
  border-right: 1px solid #ccc;
}

.bold >>> legend {
  font-weight: 500;
}
</style>
